import { client } from '../http';

export default {
  async generateCode({ phoneNumber }) {
    return await client.post('/api/no-auth/login/generate-code', { phoneNumber });
  },
  async authenticate({ phoneNumber, code }) {
    return await client.post('/api/no-auth/login/authenticate', { phoneNumber, code });
  },
  async loginAs({ customerToken }) {
    return await client.post('/api/no-auth/login-as', { customerToken });
  },
  async logout() {
    return await client.get('/api/logout');
  },
  async logCookies() {
    return await client.get('/api/log-cookies');
  },
  async removeToken() {
    return await client.get('/api/no-auth/remove-cookie');
  },
  async loginHelpLead({ phoneNumber, fullName }) {
    return await client.post('/api/no-auth/login-help', { phoneNumber, fullName });
  },
};
